import React = require('react');

import l10n from 'diy/util/l10n';

export default class DisclaimerView extends React.Component<any, any> {
    render() {
        let dialogSubtitle = l10n('migration.dialog.disclaimer.subtitle');
        let dialogContent = l10n('migration.dialog.disclaimer.content');

        return (
            <div>
                <h3>{l10n('migration.dialog.title')}</h3>
                <p className="subtitle">
                    <span dangerouslySetInnerHTML={{__html: dialogSubtitle}} />
                </p>
                <p className="content" style={{textAlign: "left"}}>
                    <span dangerouslySetInnerHTML={{__html: dialogContent}} />
                </p>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/startDialog/views/DisclaimerView.tsx
 **/